import { ButtonRoundSm } from '@apps-common/components/elements'
import classNames from 'classnames'
import { getUnitActivationActionIcon, UnitActivationActionType } from '../helpers/getUnitActivationActionIcon'

interface IProps {
  type: 'button' | 'submit' | 'div'
  action: string
  label?: string
  disabled?: boolean
  callback?: () => void
  className: string
  tooltip?: {
    id: string
    message: string
    place?: any
  }
}

export const ActionButton: React.FC<IProps> = ({ type = 'button', action, label, disabled, callback, className, tooltip }) => {
  const Icon = getUnitActivationActionIcon(action as UnitActivationActionType)

  return (
    <ButtonRoundSm
      type={type}
      loading={disabled}
      className={classNames(className, type === 'div' && disabled && '!bg-surface')}
      callback={() => {
        if (callback && !disabled) {
          callback()
        }
      }}
      tooltip={tooltip}
    >
      <Icon />
      {!!label && <span>{label}</span>}
    </ButtonRoundSm>
  )
}
